import { render, staticRenderFns } from "./FormDatasB.vue?vue&type=template&id=d89e916a&"
import script from "./FormDatasB.vue?vue&type=script&lang=js&"
export * from "./FormDatasB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports